import { render, staticRenderFns } from "./WxTimePicker.vue?vue&type=template&id=8772edd8&scoped=true"
import script from "./WxTimePicker.vue?vue&type=script&lang=js"
export * from "./WxTimePicker.vue?vue&type=script&lang=js"
import style0 from "./WxTimePicker.vue?vue&type=style&index=0&id=8772edd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772edd8",
  null
  
)

export default component.exports